export default "__VITE_ASSET__DtKuazb8__"